import createAxios from './axiosHttp';
export const orderTypeService = {
  getOrderTypes
};

function getOrderTypes() {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `customer/${user.extraData.customerId}/order-types`;
  return axios.get(urlPath);
}
